import { Components, Theme } from '@mui/material';

const MuiDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(theme.spacingSizes.lg),
    }),
  },
};

export default MuiDialogTitle;
